<template>
  <div class="my-card">
    <p class="my-card_top">
      <slot name="top"></slot>
    </p>
    <div class="my-card_middle">
      <!--<p>{{ myCardData.content }}</p>-->
      <slot name="middle"></slot>
    </div>
    <div class="my-card_bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>

  export default {
    name: "my-card",
    props: {
      myCardData: {
        type: Object,
        default: () => {}
      },
    },
    filters: {
    },
  }
</script>

<style lang="scss" scoped>
  @import 'common/sass/common.scss';

  .my-card {
    display: flex;
    width: 100%;
    flex-flow: column;
    text-align: left;
    padding: 10px 15px;
    background-color: $primary-color;
    border-bottom: 1px solid $gray-border-color;
    box-sizing: border-box;
    margin-bottom: 15px;
    p {
      margin: 3px;
    }
    .my-card_top {
      color: $pure-black-font-color;
      font-size: 16px;
    }
    .my-card_middle {
      font-size: 14px;
      color: $gray-font-color;
      margin: 3px 0;
    }
    .my-card_bottom {
    }
  }
</style>
